import { EpModal } from '../../components/EpModal';
import { useTranslation as t } from '../../hooks/useTranslation';
import styles from './EpModalHelpSupport.module.scss';
import { EpIcon } from '../EpIcon';

interface IEpModalHelpSupport {
  modalId: string;
  translations: unknown;
}

export const EpModalHelpSupport = ({
  translations,
  modalId,
}: IEpModalHelpSupport) => {
  const supportList = [
    {
      title: t(translations, 'Brazil Support'),
      mail: t(translations, 'brazilSupportEmail'),
      phone: t(translations, 'brazilSupportTelephone'),
      whatsApp: t(translations, 'brazilSupportTelephoneN2'),
      qrCode:
        'https://testsso.epimedmonitor.com/images/qr-code-support-epimed-solutions.png',
    },
    {
      title: t(translations, 'Belgium Support'),
      mail: t(translations, 'belgiumSupportEmail'),
    },
    {
      title: t(translations, 'France Support'),
      mail: t(translations, 'franceSupportEmail'),
    },
    {
      title: t(translations, 'Portugal Support'),
      mail: t(translations, 'portugalSupportEmail'),
    },
    {
      title: t(translations, 'Africa Support'),
      mail: t(translations, 'africaSupportEmail'),
    },
    {
      title: t(translations, 'Latin America Support'),
      mail: t(translations, 'latinAmericaSupportEmail'),
    },
  ];

  return (
    <EpModal
      modalId={modalId}
      modalTitle={t(translations, 'Support')}
      modalType="default"
      modalButtonList={[
        {
          buttonSize: 'md',
          buttonId: 'modal__button--close',
          buttonText: t(translations, 'Close'),
          buttonType: 'secondary-outline',
          isCloseButton: true,
        },
      ]}
    >
      <div style={{ height: 'max-content' }}>
        {supportList.map((support, index) => (
          <div key={index}>
            <h3 className={styles['content__title']}>{support.title}</h3>

            <div className={styles['content__support-list']}>
              <EpIcon
                iconName="SolidEnvelop"
                iconSize={24}
                customClasses={styles['content__icon']}
              />
              <a
                className={styles['content__text']}
                href={`mailto:${support.mail}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {support.mail}
              </a>
            </div>

            {support.phone && (
              <div className={styles['content__support-list']}>
                <EpIcon
                  iconName="SolidMobile"
                  iconSize={24}
                  customClasses={styles['content__icon']}
                />
                <a
                  className={styles['content__text']}
                  href={`tel: ${support.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {support.phone}
                </a>
              </div>
            )}

            {support.whatsApp && (
              <>
                <div className={styles['content__support-list']}>
                  <EpIcon
                    iconName="SolidMobile"
                    iconSize={24}
                    customClasses={styles['content__icon']}
                  />
                  <a
                    className={styles['content__text']}
                    href={`tel: ${support.whatsApp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {support.whatsApp}
                  </a>
                </div>

                <img
                  src="assets/images/qr-code-brazil-whatsapp-support-epimed-solutions.png"
                  className={styles['content__qrCode']}
                  alt="QR Code WhatsApp"
                />
              </>
            )}
          </div>
        ))}
      </div>
    </EpModal>
  );
};
